module.exports = __webpack_public_path__ + "media/images/iconInfo__accent-be69e7689b5c8b371044e9aefe5822bd.png";